<template>
	<div>
		<navigation></navigation>
		<div class="container main-container">
      <div class="columns">
        <side-menu :name="currentView" :view.sync="currentView"></side-menu>
        <router-view></router-view>
      </div>
    </div>
	</div>	
</template>

<script>
import SideMenu from '@/components/SideMenu'
import Navigation from '@/components/Navigation'

export default {
	name: 'home',

	components: {
		SideMenu,
		Navigation
	},

	data () {
		return {
			currentView: 'dashboard'
		}
	},

  firebase: {
  },

	methods: {
	},

  mounted () {
  }
}
</script>

<style scoped>
.main-container {
	padding-top: 3em;
}
</style>


// WEBPACK FOOTER //
// src/views/Home.vue